import { Avatar, Dropdown, Tag, Col, Spin, message } from "antd";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setShowIncognito } from "../../store/slice/globleSlice";
import {
  UserOutlined,
  LogoutOutlined,
  ReloadOutlined,
  ProfileOutlined,
  BellOutlined,
  NotificationOutlined,
  ExclamationCircleOutlined,
  CalculatorOutlined,
  LoadingOutlined,
  EyeOutlined,
  EyeInvisibleOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { HEADER_HEIGHT, sequence } from "../../Helper/constant";
import { setAuth } from "../../store/slice/authSlice";
import NiftySenView from "../NiftySenView/index";
import React, { useEffect, useState, useMemo, useCallback } from "react";
import { clearLocalStorage } from "../../store/store";
import { useAuthChannel } from "../../hooks/useAuthChannel";
import APICall from "../../APICall";
import EndPoints from "../../APICall/EndPoints";
import {
  StyleHeader,
  DigitalClockContainer,
  ClockBorder,
  FlipDigitContainer,
  CurrentDigit,
  Colon,
  ExpDiv,
  ValidText,
  ExpText,
  IconWrapper,
  AuthorityAvatar, // <-- add this import
} from "./index.style";
import { useCalculateMargin } from "../../APICall/apiHooks";
import { valanBillDate } from "../CommanFuction/CommanFunction";
import Notification from "./Notification";
import ThemeToggle from "../ThemeToggle";

const Header = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const isMobile = breakpoint.xs || (breakpoint.sm && !breakpoint.md);

  //state
  const [showVideo, setShowVideo] = useState(false);
  const [dragPosition, setDragPosition] = useState({ x: 0, y: 0 });
  const [marketData, setMarketData] = useState([]);
  const showIncognito = useSelector((state) => state.globleSlice.showIncognito);

  const { marginLoading, marginMutate } = useCalculateMargin({
    id: null,
    query: null,
  });
  // const { marketStatusData, marketStatusLoading } = useGetMarketStatus();

  //redux
  const userDetail = useSelector((state) => state.authSlice.userDetail);
  const hasExp = userDetail?.expiryDate;
  const isOwner = userDetail?.accountType === "owner";
  const isBroker = userDetail?.accountType === "broker";
  const { broadcastLogout } = useAuthChannel();
  // const Usertoken = useSelector((state) => state.authSlice?.accessToken);
  // const socketflag = useSelector(
  //   (state) => state?.webSocketSlice?.webSocket?.socket
  // );

  // useEffect(() => {
  //   if (marketStatusData) {
  //     const sortedArray = marketStatusData?.sort((a, b) => {
  //       const indexA = sequence.indexOf(a.marketName);
  //       const indexB = sequence.indexOf(b.marketName);

  //       if (indexA === -1) return 1;
  //       if (indexB === -1) return -1;

  //       return indexA - indexB;
  //     });
  //     const marketString = sortedArray?.reduce((acc, curr) => {
  //       if (curr?.marketName) {
  //         acc += `${curr?.marketName}:
  //         ${curr?.sessionStartTime?.slice(0, 5)} -
  //         ${curr?.sessionEndTime?.slice(0, 5)}, `;
  //       }
  //       return acc;
  //     }, "");

  //     setMarketData(marketString);
  //   }
  // }, [marketStatusData]);

  //items
  const items = useMemo(
    () => [
      {
        key: "avatar",
        label: (
          <>
            Welcome {userDetail?.accountName} ({userDetail?.userId}){" "}
            <Tag
              color="magenta"
              bordered={false}
              style={{
                fontSize: "1rem",
                marginLeft: "0.5rem",
              }}
            >
              {userDetail?.accountType}
            </Tag>
          </>
        ),
        icon: <UserOutlined />,
      },
      isOwner &&{
        key: "showIncognito",
        label: (
          <span>{showIncognito ? "Hide Incognito" : "Show Incognito"}</span>
        ),
        icon: showIncognito ?<EyeInvisibleOutlined />:<EyeOutlined /> , // You can use a different icon if you want
      },
      !isOwner &&
      !isBroker && {
        key: "profile",
        label: <span>Profile</span>,
        icon: <ProfileOutlined />,
      },
      {
        key: "resetPassword",
        label: <span>Reset Password</span>,
        icon: <ReloadOutlined />,
      },
      isOwner && {
        key: "ResetAllMargin",
        label: <span>Re-set All Margin</span>,
        icon: <CalculatorOutlined />,
      },
      isOwner && {
        key: "removeExpiredScripts",
        label: <span>Remove Expired Scripts</span>,
        icon: <DeleteOutlined />,
      },
      {
        key: "RulesAndRegulation",
        label: <span>Rules And Regulation</span>,
        icon: <ExclamationCircleOutlined />,
      },
      {
        key: "logout",
        label: <span>Logout</span>,
        icon: <LogoutOutlined />,
      },
    ],
    [userDetail, showIncognito]
  );
  // console.log("render");

  //api call
  const logout = useCallback(async () => {
    try {
      let response = await APICall("post", EndPoints.userLogout);
      console.log("response Logout", response);
    } catch (error) {
      console.log("error", error);
    } finally {
      dispatch(setAuth(null));
      clearLocalStorage();
      localStorage.clear();
      sessionStorage.clear();
      broadcastLogout();
      navigate("/login");
    }
  }, [dispatch, navigate, broadcastLogout]);

  //functions
  const handleMenuClick = useCallback(
    async (value) => {
      if (value?.key === "logout") {
        logout();
      } else if (value?.key === "resetPassword") {
        navigate("/resetPassward");
      } else if (value?.key === "profile") {
        navigate("/profile");
      } else if (value?.key === "RulesAndRegulation") {
        navigate("/rules-and-regulation");
      } else if (value?.key === "ResetAllMargin") {
        marginMutate();
      } else if (value?.key === "showIncognito") {
        dispatch(setShowIncognito(!showIncognito));
      } else if (value?.key === "removeExpiredScripts") {
        try {
          const response = await APICall("post", EndPoints.cleanupStaleScripts);
          message.success(response?.data?.message || "Expired scripts removed successfully");
        } catch (error) {
          console.log("error", error);
          message.error(error?.response?.data?.message || "Failed to remove expired scripts");
        }
      }
    },
    [logout, navigate, marginMutate, showIncognito, dispatch]
  );

  const menuProps = useMemo(
    () => ({
      items,
      onClick: handleMenuClick,
    }),
    [items, handleMenuClick]
  );
  return (
    <StyleHeader>
      <div style={{ display: "flex", alignItems: "center" }}>
        <Col style={{ alignItems: "start" }}>
          <NiftySenView />
        </Col>
      </div>

      <div
        // style={style.icon_wrapper}
        style={{ display: "flex", alignItems: "center" }}
      >
        <>
          {/* <div style={{ position: "relative", marginRight: "1rem" }}>
          <Tooltip title={"CNBC LIVE"}>
            <PlaySquareOutlined
              style={{ fontSize: "24px", color: "white", cursor: "pointer" }}
              onClick={() => setShowVideo(true)}
            />
          </Tooltip>
          {showVideo && (
            <Draggable
              position={dragPosition}
              onDrag={(e, data) => setDragPosition({ x: data.x, y: data.y })}
              bounds="body"
            >
              <div
                style={{
                  position: "fixed",
                  zIndex: 1000,
                  boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                  background: "#f0f0f0",
                  padding: "10px",
                  borderRadius: "4px",
                  cursor: "move",
                }}
              >
                <div
                  style={{
                    padding: "5px",
                    marginBottom: "5px",
                    background: "#e0e0e0",
                    textAlign: "center",
                    borderRadius: "4px",
                    display: "flex",
                    color: "black",

                    justifyContent: "space-between",
                  }}
                >
                  <Typography.Text style={{ fontWeight: "600" }}>
                    CNBC LIVE
                  </Typography.Text>

                  <CloseOutlined
                    style={{
                      fontSize: "15px",
                      cursor: "pointer",
                    }}
                    onClick={() => setShowVideo(false)}
                  />
                </div>

                <iframe
                  width="560"
                  height="315"
                  src={`https://www.youtube.com/embed/${"Uyr9dCg0JyQ"}?autoplay=1&rel=0`}
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
            </Draggable>
          )}
        </div> */}
        </>

        {/* <ScrollingText marketData={marketData} /> */}
        <div style={{ marginRight: "1rem" }}>
          <Notification />
        </div>
        {hasExp && (
          <ExpDiv>
            <ValidText>Valid till</ValidText>
            <ExpText>{valanBillDate(hasExp)}</ExpText>
          </ExpDiv>
        )}
        <DigitalClock />
        <IconWrapper>
          <ThemeToggle />
        </IconWrapper>
        <IconWrapper>
          {marginLoading ? (
            <Spin indicator={<LoadingOutlined spin />} />
          ) : (
            <Dropdown
              menu={menuProps}
              placement="bottomLeft"
              arrow={{
                pointAtCenter: true,
              }}
            >
              <AuthorityAvatar authorityLevel={userDetail?.authorityLevel}>
                <Avatar size={"small"}>
                  {userDetail?.accountName
                    ? userDetail.accountName.slice(0, 2).toUpperCase()
                    : <UserOutlined />}
                </Avatar>
              </AuthorityAvatar>
            </Dropdown>
          )}
        </IconWrapper>
      </div>
    </StyleHeader>
  );
};

export default React.memo(Header);

const DigitalClock = React.memo(() => {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const intervalId = setInterval(() => {
      setTime(new Date());
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  const hours = time.getHours().toString().padStart(2, "0");
  const minutes = time.getMinutes().toString().padStart(2, "0");
  const seconds = time.getSeconds().toString().padStart(2, "0");

  return (
    <DigitalClockContainer>
      <ClockBorder>
        <FlipDigit digit={hours[0]} />
        <FlipDigit digit={hours[1]} />
        <Colon>:</Colon>
        <FlipDigit digit={minutes[0]} />
        <FlipDigit digit={minutes[1]} />
        <Colon>:</Colon>
        <FlipDigit digit={seconds[0]} />
        <FlipDigit digit={seconds[1]} />
      </ClockBorder>
    </DigitalClockContainer>
  );
});

const FlipDigit = React.memo(({ digit }) => {
  const [flip, setFlip] = useState(false);

  // useEffect(() => {
  //   const timeout = setTimeout(() => {
  //     setFlip(true);
  //   }, 500);

  //   return () => clearTimeout(timeout);
  // }, [digit]);

  // useEffect(() => {
  //   const timeout = setTimeout(() => {
  //     setFlip(false);
  //   }, 1000);

  //   return () => clearTimeout(timeout);
  // }, [digit, flip]);

  return (
    <FlipDigitContainer>
      {/* <TopDigit flip={flip.toString()}>{digit}</TopDigit> */}
      <CurrentDigit>{digit}</CurrentDigit>
      {/* <BottomDigit flip={flip.toString()}>{digit}</BottomDigit> */}
    </FlipDigitContainer>
  );
});

// const ScrollingText = React.memo(({ marketData }) => {
//   const duration = marketData.length * 0.1; //
//   return (
//     <TickerContainer>
//       <ScrollingMessage duration={duration}>{marketData}</ScrollingMessage>
//     </TickerContainer>
//   );
// });
